import { render, staticRenderFns } from "./TheEventCalendar.vue?vue&type=template&id=d8456c06&scoped=true&"
import script from "./TheEventCalendar.vue?vue&type=script&lang=ts&"
export * from "./TheEventCalendar.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=d8456c06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8456c06",
  null
  
)

export default component.exports